<template>
    <Button type="button" :label="text" :icon="iconVal" :badge="badge"
        :class="[
            type ? 'p-button-' + type : '',
            size ? 'p-button-' + size : 'p-button',
            {
                'p-button-raised': raised,
                'p-button-rounded': round,
                'p-button-outlined': plain
            }
        ]" 
        :badgeClass="badge_type ? 'p-badge-' + badge_type : ''"
        style="display: block;flex-shrink: 0;">
        <slot></slot>
    </Button>
</template>

<script>
import { computed } from 'vue'
import Button from 'primevue/button';

export default {
    components: {
        Button
    },
    name: 'tw-button',
    props: {
        text: {
            type: String,
            default: '按钮'
        },
        type: {
            // '','secondary','success','info','warning','help','danger','text'
            default: null
        },
        size: {
            // 'sm','','lg'
            default: 'sm'
        },
        plain: null,
        round: null,
        icon: null,
        raised: null,
        badge: {
            type: String,
            default: null
        },
        badge_type: {
            // '','secondary','success','info','warning','help','danger','text'
            default: null
        }
    },
    setup(props) {
        const iconVal = computed(() => {
            if (props.icon) {
                return props.icon
            } else {
                let iconTemp = null
                if(props.type){
                    if(props.type === 'secondary'){
                        iconTemp = 'pi pi-send'
                    }else if(props.type === 'success'){
                        iconTemp = 'pi pi-check'
                    }else if(props.type === 'info'){
                        iconTemp = 'pi pi-info-circle'
                    }else if(props.type === 'warning'){
                        iconTemp = 'pi pi-exclamation-triangle'
                    }else if(props.type === 'help'){
                        iconTemp = 'pi pi-tag'
                    }else if(props.type === 'danger'){
                        iconTemp = 'pi pi-times'
                    }
                }
                return iconTemp
            }
        })

        return {
            iconVal
        }
    }
}
</script>
